import React, { useEffect, useMemo } from 'react'
import { useDropzone } from 'react-dropzone'
import { TouchableOpacity } from 'react-native'

import {
  builderInvoiceUpload,
  dropzoneOptions,
  invoiceUploadError,
} from '../../../utils/helpers/builderInvoiceUpload'
import { useMessage } from '../../../utils/helpers/MessageProvider'

type props = {
  children: React.ReactNode
  navigation: any
  onSuccess?: () => void
}

export const UploadInvoiceButtonContext = React.createContext({
  onPress: () => {},
})

export const UploadInvoiceButton = ({
  children,
  navigation,
  onSuccess,
}: props) => {
  const { open, acceptedFiles, getInputProps, fileRejections } =
    useDropzone(dropzoneOptions)
  const { setMessage } = useMessage()

  useEffect(() => {
    if (acceptedFiles.length < 1) {
      return
    }
    builderInvoiceUpload(navigation, acceptedFiles, onSuccess)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptedFiles])

  useEffect(() => {
    if (fileRejections.length > 0) {
      invoiceUploadError(fileRejections, setMessage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileRejections])

  const contextProps = useMemo(
    () => ({
      onPress: open,
    }),
    [open],
  )

  return (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <input {...getInputProps()} />
      <TouchableOpacity onPress={open}>
        <UploadInvoiceButtonContext.Provider value={contextProps}>
          {children}
        </UploadInvoiceButtonContext.Provider>
      </TouchableOpacity>
    </>
  )
}
